import { Button } from '@/components/Button';
import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface EditableBoxProps {
  isDisabled: boolean;
}

export const SearchButton = styled(Button)`
  border-radius: 8px;
  padding: 4px 4px;
`;

export const ParameterNameTypography = styled(Typography)`
  display: '-webkit-box';
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
`;

export const EditableBox = styled(Box)<EditableBoxProps>`
  background-color: ${({ isDisabled, theme }) =>
    isDisabled
      ? theme.palette.primary['01'] + '70'
      : theme.palette.success.light + '70'};
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 8px;
  cursor: pointer;
`;

export const CancelBox = styled(Box)`
  background-color: ${({ theme }) => theme.palette.status.offline + '70'};
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 8px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.status.offline};
`;

export const DescriptionComponent = styled('div')`
  padding: 8px 8px;
  background-color: ${({ theme }) => theme.palette.grey['03']};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey['05']};
  margin-bottom: 4px;
  font-size: 12px;
`;

export const ParmetersTableSearchBox = styled(Stack)`
  direction: row;
  gap: 4px;
  align-items: center;
  margin-bottom: 8px;
`;
